/**
 * Keyboard Navigation Detection
 * Adds 'keyboard-nav' or 'mouse-nav' class to body based on user input method
 * This allows for enhanced focus indicators for keyboard users while keeping
 * mouse interactions clean
 */

let isKeyboardUser = false;

// Detect keyboard navigation
const handleKeyDown = (e) => {
  if (e.key === 'Tab') {
    isKeyboardUser = true;
    document.body.classList.add('keyboard-nav');
    document.body.classList.remove('mouse-nav');
  }
};

// Detect mouse navigation
const handleMouseDown = () => {
  isKeyboardUser = false;
  document.body.classList.add('mouse-nav');
  document.body.classList.remove('keyboard-nav');
};

// Initialize on DOM load
export const initKeyboardNavDetection = () => {
  // Set initial state
  document.body.classList.add('mouse-nav');
  
  // Add event listeners
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('mousedown', handleMouseDown);
  
  // Cleanup function
  return () => {
    document.removeEventListener('keydown', handleKeyDown);
    document.removeEventListener('mousedown', handleMouseDown);
  };
};

// Check if user is currently using keyboard
export const isUsingKeyboard = () => isKeyboardUser;

export default initKeyboardNavDetection;
